'use client';
import {
  DANGER_700,
  GREY_700,
  GREY_900,
  GREY_1000,
  RADIUS_MD,
  TEXT_FONT,
} from '@mnd-frontend/ui/shared/tokens';
import { components, defaultTheme } from 'react-select';
import styled, { css } from 'styled-components';

type Props = Parameters<typeof components.SelectContainer>[number];

const SelectContainer = (props: Props) => (
  <components.SelectContainer {...props} theme={defaultTheme} />
);

const StyledSelectContainer: any = styled(SelectContainer).attrs(props => ({
  innerProps: {
    ...props.innerProps,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    'data-testid': props.selectProps['data-testid'] ?? 'select-container',
  },
}))`
  && {
    font-family: ${TEXT_FONT};
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.25;
    display: inline-block;
    text-align: left;
    width: ${({ selectProps }: { selectProps: any }) => selectProps.width ?? '100%'};
    min-width: ${({ selectProps }: { selectProps: any }) => selectProps.minWidth};
    max-width: ${({ selectProps }: { selectProps: any }) => selectProps.maxWidth};

    vertical-align: top;
    pointer-events: auto;
    background: transparent;
    outline: 1px solid ${GREY_700};
    outline-offset: -1px;
    border-radius: ${RADIUS_MD};
    resize: none;
    min-height: 2.75rem;

    ${({ selectProps }: { selectProps: any }) =>
      selectProps.errorMessage &&
      css`
        border-color: ${DANGER_700};

        box-shadow: 0 0 0 1px ${DANGER_700};
      `};

    ${({ isFocused }) =>
      isFocused &&
      css`
        outline: 2px solid ${GREY_900};
        outline-offset: -2px;
        border-color: transparent;
      `}

    ${({ isDisabled }) =>
      isDisabled &&
      css`
        opacity: 0.5;
      `}

    li {
      margin-bottom: auto;
    }

    input {
      color: ${GREY_1000};
      font-family: ${TEXT_FONT};
      font-size: 1rem;
      font-weight: normal;
      line-height: 1.25;
    }
  }
`;

export default StyledSelectContainer;
